import { render, staticRenderFns } from "./ChooseYourPath.vue?vue&type=template&id=d4d3dbfe&scoped=true&"
import script from "./ChooseYourPath.vue?vue&type=script&lang=js&"
export * from "./ChooseYourPath.vue?vue&type=script&lang=js&"
import style0 from "./ChooseYourPath.vue?vue&type=style&index=0&id=d4d3dbfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d3dbfe",
  null
  
)

component.options.__file = "ChooseYourPath.vue"
export default component.exports